import React from 'react';
import './ChatHeader.css';

const ChatHeader = ({ caseId, status, onBack, tenantName, bankName, userEmail }) => {
  const getStatusBadge = (status) => {
    const statusConfig = {
      'active': { label: 'In Progress', color: '#25d366' },
      'completed': { label: 'Completed', color: '#00a884' },
      'pending': { label: 'Pending', color: '#ffb74d' },
      'closed': { label: 'Closed', color: '#8696a0' }
    };

    const config = statusConfig[status] || statusConfig['active'];

    return (
      <span 
        className="status-badge" 
        style={{ backgroundColor: config.color }}
      >
        {config.label}
      </span>
    );
  };

  return (
    <div className="chat-header">
      <div className="chat-header-left">
        <button className="back-button" onClick={onBack} title="Go back">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path 
              d="M15 18l-6-6 6-6" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className="chat-header-info">
          {tenantName && (
            <div className="header-tenant-badge">
              🏢 {tenantName}
            </div>
          )}
          <div className="case-title">
            <h2 className="case-number-display">{caseId}</h2>
            {getStatusBadge(status)}
          </div>
          {bankName && (
            <p className="case-subtitle">🏦 {bankName}</p>
          )}
          {userEmail && (
            <p className="tenant-info">👤 {userEmail}</p>
          )}
        </div>
      </div>

      <div className="chat-header-right">
        <button className="header-icon-button" title="More options">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <circle cx="12" cy="5" r="2"/>
            <circle cx="12" cy="12" r="2"/>
            <circle cx="12" cy="19" r="2"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
